import { EntityRepository, Repository } from "typeorm";
import { LocationWiseTranfers } from "../entities/location-wise-transfers.entity";

@EntityRepository(LocationWiseTranfers)
export class LocationWiseStockLogRepository extends Repository<LocationWiseTranfers>{

}